var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 8.2C7.25 5.46619 9.46619 3.25 12.2 3.25H15.8C18.5338 3.25 20.75 5.46619 20.75 8.2V11.8C20.75 14.5338 18.5338 16.75 15.8 16.75H12.2C9.46619 16.75 7.25 14.5338 7.25 11.8V8.2ZM12.2 4.75C10.2946 4.75 8.75 6.29462 8.75 8.2V11.8C8.75 13.7054 10.2946 15.25 12.2 15.25H15.8C17.7054 15.25 19.25 13.7054 19.25 11.8V8.2C19.25 6.29462 17.7054 4.75 15.8 4.75H12.2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 13C3.25 10.3766 5.37665 8.25 8 8.25C8.41421 8.25 8.75 8.58579 8.75 9C8.75 9.41421 8.41421 9.75 8 9.75C6.20507 9.75 4.75 11.2051 4.75 13V16.4C4.75 18.2502 6.24985 19.75 8.1 19.75H10.4C12.2502 19.75 13.75 18.2502 13.75 16.4V16C13.75 15.5858 14.0858 15.25 14.5 15.25C14.9142 15.25 15.25 15.5858 15.25 16V16.4C15.25 19.0786 13.0786 21.25 10.4 21.25H8.1C5.42142 21.25 3.25 19.0786 3.25 16.4V13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4829c470.svg";
export { ForwardRef as ReactComponent };